@if (!wrapControls) {
  <div class="row">
    <ng-template [ngTemplateOutlet]="startDateTemplate"/>
    <ng-template [ngTemplateOutlet]="endDateTemplate"/>
  </div>
} @else {
  <div class="row">
    <ng-template [ngTemplateOutlet]="startDateTemplate"/>
  </div>
  <div class="row">
    <ng-template [ngTemplateOutlet]="endDateTemplate"/>
  </div>
}
<div class="row">
  <div class="col">
    @if (showErrors) {
      <app-errors [errors]="getOtherErrors()"/>
    }
  </div>
</div>

<ng-template #startDateTemplate>
  <div [class]="!fillHorizontalWidth ? 'col-auto' : 'col'" [formGroup]="controls">
    <app-date-time-select [label]="label ? (label[ControlNames.START_DATE_CONTROL_NAME] | messageTranslate): null" [showTime]="showTime" [showErrors]="showErrors"
                          [placement]="placement" [minDate]="minDate" [maxDate]="maxDateForStartDate" [readOnly]="readOnly"
                          [timezone]="effectiveTimezone" [formControlName]="ControlNames.START_DATE_CONTROL_NAME" [helpText]="startDateHelpText"
                          (navigate)="onNavigate(ControlNames.START_DATE_CONTROL_NAME, $event)" (closed)="onClosed(ControlNames.START_DATE_CONTROL_NAME)"
                          (blur)="onTouched()"/>
  </div>
</ng-template>

<ng-template #endDateTemplate>
  <div [class]="!fillHorizontalWidth ? 'col-auto' : 'col'" [formGroup]="controls">
    <app-date-time-select [label]="label ? (label[ControlNames.END_DATE_CONTROL_NAME] | messageTranslate) : null" [showTime]="showTime" [showErrors]="showErrors"
                          [placement]="placement" [minDate]="minDateForEndDate" [maxDate]="maxDate" [readOnly]="readOnly"
                          [timezone]="effectiveTimezone" [formControlName]="ControlNames.END_DATE_CONTROL_NAME" [helpText]="endDateHelpText"
                          (navigate)="onNavigate(ControlNames.END_DATE_CONTROL_NAME, $event)" (closed)="onClosed(ControlNames.END_DATE_CONTROL_NAME)"
                          (blur)="onTouched()"/>
  </div>
</ng-template>
